import { render, staticRenderFns } from "./DdMoveConfig.vue?vue&type=template&id=e0d7c0c6&scoped=true"
import script from "./DdMoveConfig.vue?vue&type=script&lang=js"
export * from "./DdMoveConfig.vue?vue&type=script&lang=js"
import style0 from "./DdMoveConfig.vue?vue&type=style&index=0&id=e0d7c0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d7c0c6",
  null
  
)

export default component.exports